import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { connect } from "react-redux";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
import ActivityFrequencySelector from "../components/ActivityFrequencySelector";
import DailyActivityChart from "../components/DailyActivityChart";
import WeeklyActivityChart from "../components/WeeklyActivityChart";
import SelectMenuActivities from "../components/SelectMenuActivities";
import ActivityLegend from "../components/ActivityLegend";
import NoActivities from "../components/NoActivities";
import PopupWrapper from "../components/PopupWrapper";
import { activityActions } from "../_actions";
import Timeline from "../components/Timeline";
import OffDailyActivityChart from "../components/OffDailyActivityChart";
import OffWeeklyActivityChart from "../components/OffWeeklyActivityChart";

class AssistedLivingActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // offDayAlertsHidden: true,
      // offWeekAlertsHidden: true,
      offAlertsNumber: 0,
    };
    let time;

    const params = new URLSearchParams(props.location.search);

    if (params.get("timestamp") !== null) {
      time = params.get("timestamp");
    } else {
      time = Math.round(+new Date() / 1000);
    }

    if (params.get("tab") === "daily") {
      this.props.dispatch(activityActions.setActivityFrequency("day"));

      this.props.dispatch(
        activityActions.getOffDayAlerts(
          this.props.authentication.user.dependant_user_id,
          time
        )
      );
    } else if (params.get("tab") === "weekly") {
      this.props.dispatch(activityActions.setActivityFrequency("week"));
      this.props.dispatch(
        activityActions.getWeeklyDetail(
          this.props.authentication.user.dependant_user_id,
          time
        )
      );
    } else {
      this.props.dispatch(
        activityActions.getTimeline(
          this.props.authentication.user.dependant_user_id,
          time
        )
      );
    }

    this.props.dispatch(activityActions.setDetailItem(time));
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.activity.activityFrequency !==
      prevProps.activity.activityFrequency
    ) {
      const params = new URLSearchParams(this.props.location.search);

      let time;
      if (params.get("timestamp") !== null) {
        time = params.get("timestamp");
      } else {
        time =
          this.props.activity.detailItem > 0
            ? this.props.activity.detailItem
            : // : Math.round(+new Date() / 1000);
              null;
      }
      if (this.props.activity.activityFrequency === "day") {
        this.props.dispatch(
          activityActions.getOffDayAlerts(
            this.props.authentication.user.dependant_user_id,
            time
          )
        );
      } else if (this.props.activity.activityFrequency === "week") {
        this.props.dispatch(
          activityActions.getWeeklyDetail(
            this.props.authentication.user.dependant_user_id,
            time
          )
        );
      } else if (this.props.activity.activityFrequency === "timeline") {
        this.props.dispatch(
          activityActions.getTimeline(
            this.props.authentication.user.dependant_user_id,
            time
          )
        );
      }

      this.props.dispatch(activityActions.setDetailItem(time));
    } else if (
      this.props.activity.detailItem !== prevProps.activity.detailItem
    ) {
      if (this.props.activity.activityFrequency === "day") {
        // this.props.dispatch(
        //   activityActions.getDailyDetail(
        //     this.props.authentication.user.dependant_user_id,
        //     this.props.activity.detailItem
        //   )
        // );

        this.props.dispatch(
          activityActions.getOffDayAlerts(
            this.props.authentication.user.dependant_user_id,
            this.props.activity.detailItem
          )
        );
      } else if (this.props.activity.activityFrequency === "week") {
        this.props.dispatch(
          activityActions.getWeeklyDetail(
            this.props.authentication.user.dependant_user_id,
            this.props.activity.detailItem === "Last 7 days"
              ? null
              : this.props.activity.detailItem
          )
        );
      }
    }
  }

  handleOnDayChange = (isHidden) => {
    this.props.dispatch(activityActions.setDailyOffAlertsToggle(isHidden));
  };
  handleOnWeekChange = (isHidden) => {
    this.props.dispatch(activityActions.setWeeklyOffAlertsToggle(isHidden));
  };

  render() {
    const {
      fetchingDetail,
      detail,
      activityFrequency,
      offDayAlertsHidden,
      offWeekAlertsHidden,
    } = this.props.activity;

    console.log("off alerts is currently set to: ", offDayAlertsHidden);

    let totalOffAlerts = 0;

    if (this.props.activity.detail["inactivities"] !== undefined) {
      this.props.activity.detail.inactivities.map((item) => {
        totalOffAlerts += item.num_inac_alerts;
      });
    } else if(!fetchingDetail && detail && 'num_alerts' in detail && 'inactivity' in detail.num_alerts) {
      totalOffAlerts = Object.values(detail.num_alerts.inactivity).reduce((total, count) => total + count, 0);
    }

    if (totalOffAlerts === 0 && offDayAlertsHidden === false) {
      this.props.dispatch(activityActions.setDailyOffAlertsToggle(true));
    }
    if (totalOffAlerts === 0 && offWeekAlertsHidden === false) {
      this.props.dispatch(activityActions.setWeeklyOffAlertsToggle(true));
    }

    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle title={"Activities"} subTitle={"See what has happened."} />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          <ActivityFrequencySelector {...this.props} />

          {fetchingDetail && <Loading />}
          {activityFrequency === "timeline" && (
            <div>
              <Timeline {...detail} />
            </div>
          )}
          {!fetchingDetail && detail.activities && detail.activities.length && (
            <div>
              {activityFrequency === "day" && (
                <div>
                  {detail.available && <SelectMenuActivities {...this.props} />}
                  <ActivityLegend
                    offAlertsNumber={totalOffAlerts}
                    offAlertsHidden={offDayAlertsHidden}
                    onChange={this.handleOnDayChange}
                  />
                  <div className={css(!offDayAlertsHidden && styles.hidden)}>
                    <DailyActivityChart {...this.props} />
                  </div>
                  {!offDayAlertsHidden && (
                    <OffDailyActivityChart {...this.props} />
                  )}
                </div>
              )}
              {activityFrequency === "week" && (
                <div>
                  {detail.available && <SelectMenuActivities {...this.props} />}
                  <ActivityLegend
                    offAlertsNumber={totalOffAlerts}
                    offAlertsHidden={offWeekAlertsHidden}
                    onChange={this.handleOnWeekChange}
                  />
                  <div className={css(!offWeekAlertsHidden && styles.hidden)}>
                    <WeeklyActivityChart {...this.props} />
                  </div>
                  {!offWeekAlertsHidden && (
                    <div>
                      <OffWeeklyActivityChart {...this.props} />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.activity;
  const { alert, history } = state;
  const activity = state.activity;
  const authentication = state.authentication;

  return {
    fetchingDetail,
    alert,
    history,
    activity,
    authentication,
  };
}

export default connect(mapStateToProps)(AssistedLivingActivities);
